<div *ngIf="activity.due_at" class="activity-due-date" [ngClass]="{'red': isPastDue()}">
	<ng-container *ngIf="withDateLabel">
		<span class="due-date-label-full">{{ 'activity-list_due-date' | translate }}:&nbsp;</span>
		<span class="due-date-label-partial">{{ 'activity-list_due' | translate }}:&nbsp;</span>
	</ng-container>
	<span class="due-date-full">{{activity.due_at | date}}</span>
	<span class="due-date-partial">{{activity.due_at | date: 'shortDate'}}</span>
</div>
<span *ngIf="!activity.due_at" class="no-date">—</span>
